import React from "react";

import {Home} from "../components/Home/Home";

export const HomeView = () => <Home/>;


